var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.96 6.17C18.96 7.56 20.34 9.77 20.62 12.32",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49023 12.37C3.75023 9.83 5.11023 7.62 7.09023 6.22",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19043 20.94C9.35043 21.53 10.6704 21.86 12.0604 21.86C13.4004 21.86 14.6604 21.56 15.7904 21.01",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0603 7.7C13.5956 7.7 14.8403 6.45535 14.8403 4.92C14.8403 3.38465 13.5956 2.14 12.0603 2.14C10.5249 2.14 9.28027 3.38465 9.28027 4.92C9.28027 6.45535 10.5249 7.7 12.0603 7.7Z",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8298 19.92C6.36516 19.92 7.60981 18.6754 7.60981 17.14C7.60981 15.6046 6.36516 14.36 4.8298 14.36C3.29445 14.36 2.0498 15.6046 2.0498 17.14C2.0498 18.6754 3.29445 19.92 4.8298 19.92Z",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1696 19.92C20.705 19.92 21.9496 18.6754 21.9496 17.14C21.9496 15.6046 20.705 14.36 19.1696 14.36C17.6343 14.36 16.3896 15.6046 16.3896 17.14C16.3896 18.6754 17.6343 19.92 19.1696 19.92Z",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsInactive);
export default __webpack_public_path__ + "static/media/Integrations_inactive.ee1b555470d48af737f273c0a4c50441.svg";
export { ForwardRef as ReactComponent };